import React, { FC } from 'react';
import { Image, ImageProps, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import useAuthImage from 'core/utils/useAuthImage';

interface AuthImageProps extends Omit<ImageProps, 'src'> {
    src: string | null | undefined;
}

const AuthImage: FC<AuthImageProps> = ({ src, style, className, ...props }) => {
    const { blobUrl, loading } = useAuthImage(src);

    if (loading) {
        return (
            <div
                className={className}
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#f5f5f5',
                    ...style,
                }}>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: '#DA0812' }} spin />} />
            </div>
        );
    }

    return <Image src={blobUrl ?? ''} style={style} className={className} {...props} />;
};

export default AuthImage;
